@if (HasRequiredPermissions) {
  @if (hasWebSocketChanges()) {
    <div class="absolute top-[3.2em] right-[1.5em] px-3 py-0 bg-yellow-50 border border-yellow-500 rounded-lg flex items-center justify-between z-50">
      <span class="text-xs text-yellow-800">
        {{ 'Record ' | translate }} {{ 'modified' | translate }}.
        ({{ totalModifiedCount() }} {{ 'changes' | translate }})
      </span>
    </div>
  }
  @if (EntityInstance || isNew()) {
    <div [fieldContext]="this" class="flex flex-col h-full">
      <div class="px-6 pt-4 pb-2">
        <h4 class="text-[0.9em] font-medium text-gray-500 z-[999]">
          @if (isNew()) {
            {{ 'entities.delivery.newEntity' | translate }}
          } @else {
            {{ 'entities.delivery.detailEntity' | translate }}
          }
        </h4>
        <div class="flex justify-between items-center">
          <button (click)="cancelEdit()" data-testid="detail-close" class="absolute top-2 right-2 text-gray-500 hover:text-gray-700 transition-colors">
            <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>
      </div>
      <div #scrollContainer class="{{Skin.detailContainer}} flex-1 overflow-auto">
        <div class="{{this.UpdateMode}}">
          <h3 class="{{Skin.formSectionSmallTitle}}">
            <i class="fas fa-box mr-2"></i> {{ 'vues.delivery.detail.sections.delivery-info' | translate }}
          </h3>
          <div class="space-y-2">
            <!-- Photo Upload (Package) — centré -->
            <div class="flex justify-center">
              <div class="relative w-[140px] h-[180px] border border-gray-300 overflow-hidden rounded-[10px] border-[3px] border-gray-100 shadow-[0_7px_7px_rgba(0,0,0,0.1)]">
                <i class="fas fa-box absolute inset-0 text-gray-400 text-[120px] flex items-center justify-center pointer-events-none" [ngClass]="{'hidden': imageUrl}"></i>
                <img [src]="imageUrl || ''" class="w-full h-full object-cover" [ngClass]="{'hidden': !imageUrl}" />
                <div class="absolute bottom-0 left-0 flex">
                  <input type="file" #fileInput accept="image/*" (change)="onFileSelected($event,'imagePackage.rawData_Path')" class="hidden" />
                  <button type="button" (click)="fileInput.click()" class="bg-teal-500 hover:bg-teal-800 text-white px-2 py-1 text-xs font-xs">
                    <i class="fa fa-camera text-[0.9rem]"></i>
                  </button>
                  <button type="button" (click)="resetImage()" class="{{Skin.btnAlert}} px-2 py-1 text-xs font-xs">
                    <i class="fas fa-times text-[0.9rem]"></i>
                  </button>
                </div>
              </div>
            </div>
            <!-- Champ selectedPK_Pos -->
            <app-field-wrapper property="selectedPK_Pos" businessProperty="fK_PointOfService" label="entities.delivery.propreties.fK_PointOfService">
              <app-multi-select #multiSelect
                [options]="pointOfServiceLookup()"
                [placeholder]="'Select Site'"
                [maxItems]="1"
                [isMultiselect]="false"
                [selectedKeys]="editingEntity()?.selectedPK_Pos || []"
                (selectedKeysChange)="onPOSselectChange($event)"
                onReady
                (autoBind)="bindingHandler($event, 'selectedPK_Pos', multiSelect)">
              </app-multi-select>
            </app-field-wrapper>
            <!-- Champ DeliveryId (readonly, comme visitId) -->
            <app-field-wrapper property="deliveryId">
              <input type="text" readonly
                [readonly]="true"
                onReady
                class="{{Skin.formInputSmallSize}} w-full border border-gray-400 p-2 rounded-[6px] bg-gray-100 readonly:pointer-events-none"
                (autoBind)="bindingHandler($event, 'deliveryId')">
            </app-field-wrapper>
            <!-- Champ Delivery Date -->
            <app-field-wrapper property="deliveryDate">
              <app-date-time-picker onReady
                [siteTimeZone]="fuseauDuSite"
                [selectedDateTime]="editingEntity()?.deliveryDate ?? null"
                [calendarAlign]="'bottom-left'"
                class="{{Skin.formInputSmallSize}} block bg-white"
                (autoBind)="bindingHandler($event, 'deliveryDate')">
              </app-date-time-picker>
            </app-field-wrapper>
            <!-- Champ Pick-Up Date -->
            <app-field-wrapper property="pickupDate">
              <app-date-time-picker onReady
                [siteTimeZone]="fuseauDuSite"
                [selectedDateTime]="editingEntity()?.pickupDate ?? null"
                [calendarAlign]="'bottom-left'"
                class="{{Skin.formInputSmallSize}} block bg-white"
                (autoBind)="bindingHandler($event, 'pickupDate')">
              </app-date-time-picker>
            </app-field-wrapper>
            <!-- Champ Status -->
            <app-field-wrapper property="status">
              <app-reactive-badge [status]="$safeNavigationMigration(editingEntity()?.status)"
                [lookupData]="translatedStatusLookup()"
                [Skin]="Skin"
                [isEditMode]="true"
                (statusChange)="onStatusChange($event)">
              </app-reactive-badge>
            </app-field-wrapper>
            <!-- Champ Recipient -->
            <app-field-wrapper property="selectedPK_Employee" businessProperty="fK_Employee" label="entities.delivery.propreties.recipient">
              <app-multi-select [options]="filteredEmployeeLookup()"
                [isMultiselect]="false"
                [allowCreate]="true"
                [placeholder]="recipientPlaceholder()"
                [maxItems]="1"
                [selectedKeys]="editingEntity()?.selectedPK_Employee || []"
                (selectedKeysChange)="onRecipientSelectChange($event)">
              </app-multi-select>
            </app-field-wrapper>
            <!-- Champ Picked-Up By -->
            <app-field-wrapper property="selectedPK_PickupBy" businessProperty="fK_PickupBy" label="entities.delivery.propreties.pickedUpBy">
              <app-multi-select [options]="filteredEmployeeLookup()"
                [isMultiselect]="false"
                [allowCreate]="true"
                [placeholder]="pickupByPlaceholder()"
                [maxItems]="1"
                [selectedKeys]="editingEntity()?.selectedPK_PickupBy || []"
                (selectedKeysChange)="onPickupBySelectChange($event)">
              </app-multi-select>
            </app-field-wrapper>
            <!-- Section Delivery Type (radio buttons verticaux) -->
            <app-field-wrapper property="deliveryType">
              <div class="flex flex-col gap-2">
                <label class="flex items-center gap-3 border border-gray-50 p-3 rounded-lg cursor-pointer hover:border-blue-400 transition-colors"
                  [class.border-blue-700]="selectedDeliveryType() === 1"
                  [class.bg-blue-50]="selectedDeliveryType() === 1">
                  <input type="radio" name="deliveryType"
                    [checked]="selectedDeliveryType() === 1"
                    [disabled]="!isEditMode()"
                    (change)="onDeliveryTypeChange(1)"
                    class="w-5 h-5 text-blue-600">
                  <span class="text-base font-medium text-gray-700">{{ 'entities.delivery.propreties.deliveryTypeParcel' | translate }}</span>
                </label>
                <label class="flex items-center gap-3 border border-gray-50 p-3 rounded-lg cursor-pointer hover:border-blue-400 transition-colors"
                  [class.border-blue-700]="selectedDeliveryType() === 2"
                  [class.bg-blue-50]="selectedDeliveryType() === 2">
                  <input type="radio" name="deliveryType"
                    [checked]="selectedDeliveryType() === 2"
                    [disabled]="!isEditMode()"
                    (change)="onDeliveryTypeChange(2)"
                    class="w-5 h-5 text-blue-600">
                  <span class="text-base font-medium text-gray-700">{{ 'entities.delivery.propreties.deliveryTypeMeal' | translate }}</span>
                </label>
              </div>
            </app-field-wrapper>
            <!-- Champ Delivery Company -->
            <app-field-wrapper property="deliveryCompany">
              <input type="text"
                onReady
                class="{{Skin.formInputSmallSize}} w-full border border-gray-400 p-2 rounded-[6px]"
                (autoBind)="bindingHandler($event, 'deliveryCompany')">
            </app-field-wrapper>
            <!-- Champ Comments -->
            <app-field-wrapper property="comments">
              <textarea rows="3"
                onReady
                class="{{Skin.formInputSmallSize}} w-full border border-gray-400 p-2 rounded-[6px] resize-y"
                (autoBind)="bindingHandler($event, 'comments')">
              </textarea>
            </app-field-wrapper>
            <!-- Signature Image (upload) -->
            <div class="mt-4">
              <label class="block text-sm font-medium text-gray-700 mb-1">{{ 'entities.delivery.propreties.imageSignature' | translate }}</label>
              <div class="w-full min-h-[100px] rounded-[6px] border border-gray-300 shadow-[0_2px_5px_rgba(0,0,0,0.15)] overflow-hidden bg-white flex items-center justify-center p-4">
                @if (editingEntity()?.imageSignature?.thumbnail_Path; as path) {
                  <img [src]="'/Documents/' + path"
                    alt="Signature"
                    class="max-w-full max-h-[140px] object-contain" />
                } @else {
                  <span class="text-gray-400">{{ 'vues.delivery.detail.no-signature' | translate }}</span>
                }
              </div>
              <div class="flex mt-2">
                <input type="file" #signatureInput accept="image/*" (change)="onFileSelected($event,'imageSignature.rawData_Path')" class="hidden" />
                <button type="button" (click)="signatureInput.click()" class="bg-teal-500 hover:bg-teal-800 text-white px-2 py-1 text-xs font-xs">
                  <i class="fa fa-camera text-[0.9rem]"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      @if (generalErrorCount() > 0) {
        <div class="mb-1 p-1 bg-orange-100 text-red-700 border border-orange-300 rounded-full text-xs sticky bottom-14 z-10 py-1 -mt-1 z-20 text-center">
          <i class="fas fa-exclamation-triangle mr-1 ml-2"></i>
          {{ generalErrorCount() }} erreur(s) dans le formulaire
        </div>
      }
      <div class="bg-stone-50 min-w-full flex space-x-1 justify-center pt-2 border-t border-gray-200">
        @if (HasEditPermission) {
          <button name="SaveButton" data-testid="detail-save"
            type="button" (click)="saveItem()"
            [disabled]="!isFormValid()"
            class="{{Skin.btnPrimary}} uppercase py-2 px-2">
            <i class="far fa-check-square mr-2"></i>
            {{ 'buttons.save' | translate }}
          </button>
        }
        @if (HasEditPermission) {
          <button name="SaveAndCloseButton" data-testid="detail-save-close"
            type="button" (click)="saveAndCloseItem()"
            [disabled]="!isFormValid()"
            class="{{Skin.btnPrimary}} uppercase py-2 px-2">
            <i class="far fa-check-square mr-2"></i>
            {{ 'buttons.save-and-close' | translate }}
          </button>
        }
        <button (click)="cancelEdit()" data-testid="detail-cancel" class="{{Skin.btnAlert}} uppercase py-2 px-2">
          <i class="fas fa-times mr-2"></i>
          {{ 'buttons.cancel' | translate }}
        </button>
      </div>
    </div>
  }
}
